"use client"

import { classNames } from "@opensea/ui-kit"
import { useItemView } from "../items/ItemViewProvider"
import { FilterLayout, type FilterLayoutProps } from "../layout/FilterLayout"
import { useUpdateTopNavHeight } from "../navigation/top-nav/hooks"
import { useHasSearchFilters } from "../search/hooks"
import { withSuspense } from "../suspense/WithSuspense"
import { useHeroHeaderView } from "./HeroHeaderViewProvider"

type Props = FilterLayoutProps

export function HeroHeaderFilterLayout({
  style,
  overrides,
  contentClassName,
  ...rest
}: Props) {
  const { available: itemViewAvailable, itemViewGroup } = useItemView()
  const { scrollBreakpoint: heroHeaderScrollBreakpoint } = useHeroHeaderView()

  return (
    <>
      <FilterLayout
        contentClassName={classNames(
          itemViewAvailable && itemViewGroup === "grid" && "mx-1",
          contentClassName,
        )}
        overrides={{
          TableHeaderProvider: {
            className: "bg-transparent lg:bg-bg-app",
          },
          ...overrides,
        }}
        style={{
          ...(heroHeaderScrollBreakpoint > 0 && {
            minHeight: `calc(100vh - ${heroHeaderScrollBreakpoint.toString()}px)`,
          }),
          ...style,
        }}
        toolbarUnderlineClassName="lg:bg-bg-app *:border-b *:border-border-1"
        topStickyVariant="after-hero-header-tab-menu"
        {...rest}
      />
      <UpdateTopNavHeight />
    </>
  )
}

const UpdateTopNavHeight = withSuspense(function UpdateTopNavHeight() {
  const hasSearchFilters = useHasSearchFilters()

  const { itemViewGroup } = useItemView()

  useUpdateTopNavHeight(
    (topNavHeight, topNavOffset) => {
      const element = document.getElementById("filter-layout-toolbar")
      if (!element) {
        return
      }

      const { top } = element.getBoundingClientRect()
      if (Math.round(top) > topNavHeight + topNavOffset) {
        return
      }

      return topNavHeight + 80 + (hasSearchFilters ? 40 : 0) + 1 // border offset
    },
    [itemViewGroup, hasSearchFilters],
  )

  return null
})
